<div class="statusContainer">
  <app-asset-hierarchy
    (assetClicked)="selectAsset($event)"
    [statusMode]="true"
    [initialSelectedAssetId]="initialSelectedAssetId"
    [initialSelectedAssetType]="initialSelectedAssetType"
  ></app-asset-hierarchy>
  <router-outlet style="display: none"></router-outlet>
</div>
